import React from 'react';
import "./intro.css";
import personaje_2 from 'assets/images/red-personaje-2.png';
import personaje_3 from 'assets/images/red-personaje-3.png';
import personaje_4 from 'assets/images/red-personaje-4.png';
import elem1 from 'assets/images/red-elem1.png';
import elem2 from 'assets/images/red-elem2.png';
import elem4 from 'assets/images/red-elem4.png';
import elem5 from 'assets/images/red-elem5.png';
import elem6 from 'assets/images/red-elem6.png';
import elem8 from 'assets/images/red-elem8.png';
import elem9 from 'assets/images/red-elem9.png';
import elem10 from 'assets/images/red-elem10.png';
import elem11 from 'assets/images/red-elem11.png';
import elem12 from 'assets/images/red-elem12.png';

export default function Intro() {
  return (
    <article className="ricoendata-intro">
      <div className="wrapper">
		<div className="elems">
        	<h2>Rico en Data</h2>
			<img src={elem11} className='elem elem11' alt="" />
        	<img src={elem2} className='elem elem2' alt="" />
        	<img src={elem4} className='elem elem4' alt="" />
        	<img src={elem5} className='elem elem5' alt="" />
        	<img src={elem5} className='elem elem5b' alt="" />
        	<img src={elem6} className='elem elem6' alt="" />
        	<img src={elem12} className='elem elem12' alt="" />
			<img src={elem1} className='elem elem1b' alt="" />
        	<img src={elem8} className='elem elem8' alt="" />
        	<img src={elem9} className='elem elem9' alt="" />
        	<img src={elem9} className='elem elem9b' alt="" />
        	<img src={elem9} className='elem elem9c' alt="" />
        	<img src={elem10} className='elem elem10' alt="" />
        	<img className="elem personaje_2" src={personaje_2} alt="" />
        	<img className="elem personaje_3" src={personaje_3} alt="" />
        	<img className="elem personaje_4" src={personaje_4} alt="" />
		</div>
        <h4>RICO.EN.DATA es un curso de formación en educación financiera diseñado por Banco Provincia y que se desarrolla en las escuelas secundarias bonaerenses.</h4>
        <p>Tiene como objetivo brindar a las y los estudiantes de escuelas secundarias <strong>conocimientos teóricos y herramientas prácticas</strong> para tomar <strong>decisiones informadas</strong> en relación a su economía cotidiana. El proyecto en general y el contenido del curso en particular se diseñaron en coordinación con la <strong>Dirección Provincial de Educación Secundaria</strong>.</p>
        <a className='btn-verde' href="#ricoendata-calendario">Ver calendario</a>
      </div>
    </article>
  );
}